import React, { useState, useEffect, CSSProperties, useRef } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";
// import 'react-awesome-slider/dist/styles.css';
import HashLoader from "react-spinners/ClipLoader";
import {Helmet} from "react-helmet";
//import { Helmet, HelmetProvider } from "react-helmet-async";

import {isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet} from 'react-device-detect';

// 1. Import the functions
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock-upgrade';

import '../style.css';
import '../player.css';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";


//import mapProfileMap from '../assets/icon/Profile/map_profile_map.imageset/map_profile_map.png';

import globeIcon from '../assets/journey_so_far/globe.png';
import countriesIcon from '../assets/journey_so_far/countries.png';
import citiesIcon from '../assets/journey_so_far/cities.png';
import placesIcon from '../assets/journey_so_far/places.png';
import milesIcon from '../assets/journey_so_far/miles.png';
import followersIcon from '../assets/journey_so_far/followers.png';

import profilePlace from '../assets/icon/Place/place.imageset/place.jpg';
import profileShare from '../assets/icon/Share/bm_share_black.imageset/bm_share_black.png';

import placeHolder from '../assets/img/placeholder.imageset/placeholder@2x.png';

import splashScreen from '../assets/img/sonu-sood.jpeg';

import business_badge from '../assets/cdn_img/business_badge@2x.png';
import verified_icon from '../assets/cdn_img/verified-icon.png';

import * as constants from '../constants';

import ViewPost from './ViewPost';
import CommonComponent from './CommonComponent';
import TopComponent from './TopComponent';
import ExplurgerPageNotFoundMock from './ExplurgerPageNotFoundMock';

import { CommonScrollUtils } from "./CommonScrollUtils";


import useWindowDimensions from '../hooks/useWindowDimensions';
import ReactHtmlParser from 'react-html-parser';
import {localStorageTTL, getLocalStorage, setLocalStorage} from '../hooks/localStorageWithTTL';
import {openAppOrStore} from '../hooks/openAppOrStore';

import {util_isObjectEmpty, util_isObjectNotEmpty, util_getPostDataFetchKey, parseTextSinglePass} from '../hooks/util';

// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


export default function ViewProfile() {

    const [showModal, setShowModal] = useState(true);

    //const { id } = useParams();
    const { dp_link_uri } = useParams();
    const [dataFetchKey, setDataFetchKey] = useState(null);
    const [postData, setPostData] = useState([]);
    const [postCreatorInfo, setPostCreatorInfo] = useState([]);
    const [isActive, setIsActive] = useState(true);

    const [metaTagData, setMetaTagData] = useState({});
   
    const dontDismissModelHide = useRef(true);

    const initialized = useRef(false);
    const hasRun = useRef(false);

    let scrollPosition = 0;
    const optionsBodyScrollOptions = {
        reserveScrollBarGap: true,
    };

    const lockScroll = (targetElement) => {
        // console.log('ViewProfile-lockScroll:targetElement:',targetElement);
        // console.log('ViewProfile-lockScroll:isIOS:',isIOS);
        scrollPosition = window.scrollY;
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = "hidden";
            }            
            disableBodyScroll(targetElement, optionsBodyScrollOptions);
        }
        setLocalStorage('model_popup_scrollPosition', scrollPosition, 15 * 60);
        //console.log('ViewProfile-lockScroll:scrollPosition:',scrollPosition);
    };
    
    const unlockScroll = (targetElement) => {
        // console.log('ViewProfile-unlockScroll:targetElement:',targetElement);
        // console.log('ViewProfile-unlockScroll:isIOS:',isIOS);
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'unset';
                document.documentElement.style.overflow = "scroll";
            }
            enableBodyScroll(targetElement);
        }
        var _scrollPosition = getLocalStorage('model_popup_scrollPosition');
        scrollPosition = _scrollPosition;
        //console.log('ViewProfile-unlockScroll:_scrollPosition:',_scrollPosition);
        // if(isIOS)
        //     window.scrollTo(0, _scrollPosition);
    }; 
    
    /************************************** Start Fix iOS Popup scroll in iphone */

    // const handleChildClick_lockScrollNew = () => {
    //     console.log("ViewProfile-handleChildClick_lockScrollNew ");
    //     lockScrollNew();
    // };

    // const handleChildClick_unlockScrollNew = () => {
    //     console.log("ViewProfile-handleChildClick_unlockScrollNew ");
    //     unlockScrollNew();
    // };

    // const handleChildClick_preventTouchScroll = () => {
    //     console.log("ViewProfile-handleChildClick_preventTouchScroll ");
    //     preventTouchScroll();
    // };

    // const handleChildClick_enableTouchBlock = () => {
    //     console.log("ViewProfile-handleChildClick_enableTouchBlock ");
    //     enableTouchBlock();
    // };

    // const handleChildClick_disableTouchBlock = () => {
    //     console.log("ViewProfile-handleChildClick_disableTouchBlock ");
    //     disableTouchBlock();
    // };

    // let scrollYiOS = 0;

    const lockScrollNew = () => {
        //console.log("ViewProfile-lockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "hidden";
        //     // document.body.style.position = "fixed";
        //     // document.body.style.width = "100%";

        //     scrollYiOS = window.scrollY; // save current scroll
        //     document.body.style.position = "fixed";
        //     document.body.style.top = `-${scrollYiOS}px`;
        //     document.body.style.left = "0";
        //     document.body.style.right = "0";
        //     document.body.style.width = "100%";              
        // }
        CommonScrollUtils.lockScroll();
    };

    const unlockScrollNew = () => {
        //console.log("ViewProfile-unlockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "";
        //     // document.body.style.position = "";
        //     // document.body.style.width = "";

        //     document.body.style.position = "";
        //     document.body.style.top = "";
        //     document.body.style.left = "";
        //     document.body.style.right = "";
        //     document.body.style.width = "";
        //     window.scrollTo(0, scrollYiOS); // restore scroll 
                        
        // }
        CommonScrollUtils.unlockScroll();
    };  
    
    const preventTouchScroll = (e) => {
        //console.log("ViewProfile-preventTouchScroll ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     e.preventDefault();
        // }
        CommonScrollUtils.preventTouchScroll(e);
    };

    const enableTouchBlock = () => {
        //console.log("ViewProfile-enableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.addEventListener("touchmove", preventTouchScroll, { passive: false });
        // }
        CommonScrollUtils.enableTouchBlock();
    };

    const disableTouchBlock = () => {
        //console.log("ViewProfile-disableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.removeEventListener("touchmove", preventTouchScroll);
        // }
        CommonScrollUtils.disableTouchBlock();
    };    

    /************************************** End Fix iOS Popup scroll in iphone */    

    // useEffect(() => {
    //     //console.log('Component did mount');
    
    //     // Perform any setup or side-effects
    
    //     return () => {
    //         //console.log('Component will unmount');
    //         // Perform cleanup here (e.g., removing event listeners)

    //         // 5. Useful if we have called disableBodyScroll for multiple target elements,
    //         // and we just want a kill-switch to undo all that.
    //         // OR useful for if the `hideTargetElement()` function got circumvented eg. visitor
    //         // clicks a link which takes him/her to a different page within the app.
    //         clearAllBodyScrollLocks();

    //     };
    // }, []); // Empty array ensures this effect runs only on mount/unmount    

    function handleDataFromChild(data) {
        /*
            { Creater_Name: Creater_Name, Creater_ProfilePic: Creater_ProfilePic }
        */
        var mergeResult = postCreatorInfo;
        var key, value;
        for ([key, value] of Object.entries(data)) {
            mergeResult[key] = value;
        }
        setPostCreatorInfo(mergeResult);
    }    

    function handleDataFromChildCommonComponent(data) {
        dontDismissModelHide.current = data;
    }    

    function handleDataFromChildDontDismissModelHide(data) {        
        dontDismissModelHide.current = data;
    }  
    
    const redirctToAppOrWebsite = () => {
        //isMobile, isAndroid, isIOS, isWinPhone
        //console.log("redirctToAppOrWebsite-",isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet);
        // var url = constants.APP_WEBSITE_URL;       
        // if((isMobile || isTablet) && isAndroid)
        // {
        //     url = constants.APP_GOOGLE_PLAY_URL;
        // }
        // else if((isMobile || isTablet) && isIOS)
        // {
        //     url = constants.APP_APPLE_APP_STORE_URL;
        // }             
        // //console.log("redirctToAppOrWebsite-",url);   
        // //window.open(url);
        // window.location.replace(url);

        openAppOrStore();
    }    

    useEffect(() => {
        //console.log("width, height-", width, height);
        // console.log("constants.APP_TITLE:",constants.APP_TITLE);
        // console.log("constants.APP_DESCRIPTION:",constants.APP_DESCRIPTION);
        // console.log("constants.APP_IMAGE:",constants.APP_IMAGE);

        setMetaTagData({
            "APP_TITLE":constants.APP_TITLE,
            "APP_DESCRIPTION":constants.APP_DESCRIPTION,
            "APP_IMAGE":constants.APP_IMAGE
        });
    //}, [width, height]);
    }, []);    
      
    var setFetchedPostData = async (postDataReversed) => {
        //console.log("setFetchedPostData ", postDataReversed);

        var User_Status = postDataReversed.data?.User_Status;
        var Block_Status = postDataReversed.data?.Block_Status;

        //console.log("User_Status ", User_Status);
        //console.log("Block_Status ", Block_Status);
        
        // check user blocked/deleted/de-active
        if(
            (User_Status != undefined && User_Status == "1")  //user deleted/deactive
            || 
            (Block_Status != undefined && Block_Status != "0") //user blocked
        ) 
        {
            // do redirect to website/app/app store
            //redirctToAppOrWebsite();
            setPostData([])
            noProfile();
            return;
        }       
        

        var Creater_Name = postDataReversed.data.User_FirstName;
        var Creater_ProfilePic = postDataReversed.data.User_Wall_ProfilePic;
        // Cover_BG_Color : "#868586"
        var User_Profile_Cover = postDataReversed.data.User_Profile_Cover;
        var Cover_BG_Color = postDataReversed.data.Cover_BG_Color;
        var User_Handle = postDataReversed.data.User_Handle;
        var User_City = postDataReversed.data.User_City;
        var User_Country = postDataReversed.data.User_Country;
        // var Post_Text = decodeURIComponent(post.Post_Text);

        var User_Bio = postDataReversed.data.User_Bio || "";
        User_Bio = (User_Bio=="undefined")?"":User_Bio;
        //var User_Bio = decodeURIComponent(postDataReversed.data.User_Bio);



        var Level_Img_Icon = postDataReversed.data.Level_Img_Icon;
        var Level_Name = postDataReversed.data.Level_Name;

        var explurgerSummary = postDataReversed.explurgerSummary
        var i,summary;
        var explurgerSummaryData = [];
        for(i=0;i<explurgerSummary.length;i++)
        {
            summary = explurgerSummary[i];
            explurgerSummaryData[summary.Summary_Type] = summary;
        }
        //console.log(explurgerSummary,explurgerSummaryData);

        // Explurge_Msg
        var Post_Count = postDataReversed.data.Post_Count;
        //Post_Count
        var Explurge_Msg = postDataReversed.data.Explurge_Msg;

        // User_Gender : "0" 0:Male,1:Female:,

        var User_Gender = postDataReversed.data.User_Gender;

        var User_Gender_Text = "";
        if(User_Gender == "0")
        {
            User_Gender_Text = "Male";
        }
        else if(User_Gender == "1")
        {
            User_Gender_Text = "Female";
        }

        // Badge_Status
        var Badge_Status = postDataReversed.data.Badge_Status;

        // Profile_Type : "1"
        var Profile_Type = postDataReversed.data.Profile_Type;

        if(Profile_Type == "1") // Business - No Gender
        {
            User_Gender_Text = "";
        }
        
        var Profile_Category = postDataReversed.data.Profile_Category;
        if(Profile_Category==undefined || Profile_Category==null) // Creators - only show Category
        {
            Profile_Category = "";
        }

        if(Profile_Type != "2") // Creators - only show Category
        {
            Profile_Category = "";
        }

        if(Creater_ProfilePic==null || Creater_ProfilePic=="")
            Creater_ProfilePic = placeHolder;

    
        // Followers_Count: "{32} Followers"
        // Following_Count: "{22} Following"

        var Following_Count = postDataReversed.data.Following_Count;
        var Followers_Count = postDataReversed.data.Followers_Count;
        if(Following_Count==null || Following_Count=="")
            Following_Count = "{0} Following";
        if(Followers_Count==null || Followers_Count=="")
            Followers_Count = "{0} Followers";
        //console.log("Following_Count, Followers_Count", Following_Count, Followers_Count);

        
        setPostCreatorInfo({ 
            Creater_Name: Creater_Name, 
            Creater_ProfilePic: Creater_ProfilePic, 
            User_Profile_Cover:User_Profile_Cover,
            Cover_BG_Color:Cover_BG_Color,
            User_Handle:User_Handle,
            User_City:User_City,
            User_Country:User_Country,
            User_Bio:User_Bio,
            //User_Bio2:User_Bio2,
            Level_Img_Icon:Level_Img_Icon,
            Level_Name:Level_Name,
            explurgerSummaryData:explurgerSummaryData,
            Post_Count:Post_Count,
            Explurge_Msg:Explurge_Msg,
            User_Gender_Text:User_Gender_Text,
            Badge_Status:Badge_Status,
            Profile_Type:Profile_Type,
            Followers_Count:Followers_Count,
            Following_Count:Following_Count,
            Profile_Category: Profile_Category
        });

        setPostData(postDataReversed);

        // postCreatorInfo.Creater_ProfilePic
        // Creater_Name User_Handle
        // postCreatorInfo.User_Bio

        var user_title = constants.APP_TITLE;
        var user_description = constants.APP_DESCRIPTION;
        var user_image = constants.APP_CDN_URL+constants.APP_IMAGE;

        user_title = Creater_Name; // + " @ " + constants.APP_TITLE;

        if(!(!User_Bio || User_Bio.length === 0 ))
        {
            user_description = decodeURIComponent(User_Bio);
        }

        if(!(!Creater_ProfilePic || Creater_ProfilePic.length === 0 ))
        {
            user_image = Creater_ProfilePic;
        }      
        
        // console.log({
        //     "APP_TITLE":user_title,
        //     "APP_DESCRIPTION":user_description,
        //     "APP_IMAGE":user_image
        // });

        // console.log("user_title:",user_title);
        // console.log("user_description:",user_description);
        // console.log("user_image:",user_image);


        // setMetaTagData({
        //     "APP_TITLE":user_title,
        //     "APP_DESCRIPTION":user_description,
        //     "APP_IMAGE":user_image
        // });

        var dl_data = getLocalStorage("DL_Meta_Data");

        var Meta_Title = dl_data?.Meta_Title || user_title;
        var Meta_Image = dl_data?.Meta_Image || user_image;
        var Meta_Description = dl_data?.Meta_Description || user_description;
        
        if (Meta_Description == undefined || Meta_Description == "undefined" || Meta_Description == "") {
            Meta_Description = constants.APP_DESCRIPTION;
        }        

        setMetaTagData({
            "APP_TITLE":Meta_Title,
            "APP_DESCRIPTION":Meta_Description,
            "APP_IMAGE":Meta_Image
        }); 
        
        // console.log({
        //     "APP_TITLE":Meta_Title,
        //     "APP_DESCRIPTION":Meta_Description,
        //     "APP_IMAGE":Meta_Image
        // });        

        setIsActive(false);  // Loader false
        window.parent.postMessage({ action: "hideLoader" }, "*");

        //localStorageTTL, getLocalStorage, setLocalStorage

        setLocalStorage('profile_data', postDataReversed, localStorageTTL);
        //console.log("setFetchedPostData 2", postDataReversed);
    }

    var noProfile = async () => {
        setIsActive(false);  // Loader false
        // Hide loader
        window.parent.postMessage({ action: "hideLoader" }, "*");
    }


    var getPostData = async (keyID, title, body) => {
        try {

            var body = {
                "User_TokenKey": keyID,
                "User_Friends_TokenKey": keyID
            }
            await fetch(constants.API_BASE_URL + constants.profileSummary, {
                method: 'POST',
                body: JSON.stringify(body),
                title: title,
                reqId: Math.random().toString(36).slice(2),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                mode: "cors", // required in frontend
            })
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;             
                if(data.status && data.code == 200)
                {
                    //var postData = data.data;
                    //if(postData != undefined && postData != null && postData.length >0)
                    {
                        d = 1;
                        //const postDataReversed = postData.reverse();                    
                        setFetchedPostData(data);
                    }
                }   
                if(d == 0)
                {
                    noProfile();
                }                 
            })
            .catch((error) => {
                console.log("getPostData-",error);
                noProfile();
            });
        }
        catch (e) {
            console.log("e ", e)
            setPostData([])
            noProfile();
        }
    }

    var setProfilePostData = async (postData) => {
        try {
            //console.log("setProfilePostData", postData);
                // var d = 0;             
                // if(data.status && data.code == 200)
                // {
                //     //var postData = data.data;
                //     //if(postData != undefined && postData != null && postData.length >0)
                //     {
                //         d = 1;
                //         //const postDataReversed = postData.reverse();                    
                //         setFetchedPostData(postData);
                //     }
                // }   
                // if(d == 0)
                // {
                //     noProfile();
                // } 
            if(postData?.Profile_Summary != undefined && postData?.Profile_Summary)    
                setFetchedPostData(postData.Profile_Summary);
            else
                noProfile();

        }
        catch (e) {
            console.log("e ", e)
            setPostData([])
            noProfile();
        }
    }    

            // await fetch(constants.API_BASE_URL + constants.profileSummary, {
            //     method: 'POST',
            //     body: JSON.stringify(body),
            //     title: title,
            //     reqId: Math.random().toString(36).slice(2),
            //     headers: {
            //         'Content-type': 'application/json; charset=UTF-8',
            //     },
            //     mode: "cors", // required in frontend
            // })
            
    var getPostDataFetchKeyNew = async () => {
        try {
            //console.log("-------getPostDataFetchKey---------1-");
            //await util_getPostDataFetchKey(dp_link_uri, 1)

            // var body = {
            //     "User_TokenKey": keyID,
            //     "User_Friends_TokenKey": keyID
            // }


            // https://explurgerdev.com/stageapi/webviewData
            // REACT_APP_API_BASE_URL=https://explurgerdev.com/stageapi/
            // const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 
            // APP_DEEP_LINK_BASE_URL
            var body = {
                "Deep_Link_URI": constants.APP_DEEP_LINK_BASE_URL + window.location.pathname,
                "RequestType": "1"
            }            

            await fetch(constants.API_BASE_URL + "webviewData", {
                method: 'POST',
                body: JSON.stringify(body),
                //title: title,
                reqId: Math.random().toString(36).slice(2),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                mode: "cors", // required in frontend
            })            
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;  
                //console.log("data:",data);  

                // data.status && 
         
                if(data.code == 200 && data.data != undefined && util_isObjectNotEmpty(data.data))
                {
                    setLocalStorage('Video_Audio_Mute_Msg_data', data.Video_Audio_Mute_Msg, 24 * 60 * 60);
                    var postData = data.data;
                    //console.log("postData:", postData, postData.Meta_Data.length);
                    //if(postData != undefined && postData != null && postData.length >0)
                    if(postData.Meta_Data != undefined)
                    {
                        d = 1;
                        //const postDataReversed = postData.reverse();                    
                        //setFetchedPostData(data);
                        //setDataFetchKey(postData.User_TokenKey);

                        setLocalStorage('DL_Meta_Data', postData.Meta_Data, 24 * 60 * 60);
                        setLocalStorage('DL_Profile_Summary', postData.Profile_Summary, 24 * 60 * 60);
                        setLocalStorage('DL_Post_List', postData.Post_List, 24 * 60 * 60);
                        
                        //getPostData(postData.User_TokenKey, "Post Details", {}); 
                        setProfilePostData(postData);
                        //keyData = postData;
                        //console.log("-------getPostDataFetchKey---------3-",keyData);
                    }
                }   
                if(d == 0)
                {
                    noProfile();
                }                 
            })
            .catch((error) => {
                console.log("getPostDataFetchKey-",error);
                noProfile();
            });

            //console.log("getPostDataFetchKey-",keyData);
            //console.log("-------getPostDataFetchKey---------2-");

        }
        catch (e) {
            console.log("getPostDataFetchKey-e ", e);
            setPostData([]);
            noProfile();
        }
    }             
 
    var getPostDataFetchKeyOld = async () => {
        try {
            //console.log("-------getPostDataFetchKey---------1-");
            await util_getPostDataFetchKey(dp_link_uri, 1)
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;  
                //console.log("data:",data);  
         
                if(data.status && data.code == 200 && data.data != undefined && util_isObjectNotEmpty(data.data))
                {
                    var postData = data.data;
                    //console.log("postData:",postData);
                    //if(postData != undefined && postData != null && postData.length >0)
                    if(postData.User_TokenKey != undefined && postData.User_TokenKey.length > 0)
                    {
                        d = 1;
                        //const postDataReversed = postData.reverse();                    
                        //setFetchedPostData(data);
                        setDataFetchKey(postData.User_TokenKey);

                        setLocalStorage('dl_data', postData, localStorageTTL);
                        
                        getPostData(postData.User_TokenKey, "Post Details", {}); 
                        //keyData = postData;
                        //console.log("-------getPostDataFetchKey---------3-",keyData);
                    }
                }   
                if(d == 0)
                {
                    noProfile();
                }                 
            })
            .catch((error) => {
                console.log("getPostDataFetchKey-",error);
                noProfile();
            });

            //console.log("getPostDataFetchKey-",keyData);
            //console.log("-------getPostDataFetchKey---------2-");

        }
        catch (e) {
            console.log("getPostDataFetchKey-e ", e);
            setPostData([]);
            noProfile();
        }
    }     

    useEffect(() => {

        if (!initialized.current) {
            initialized.current = true; 

            /*
            if(window.location.hostname == 'localhost' && 1==0)
            {
                var postDataReversed = getLocalStorage('profile_data');
          
                if(postDataReversed == null)
                {
                    getPostData("Post Details", {}); 
                }
                else
                {
                    setFetchedPostData(postDataReversed);
                }  
            }
            else
            {
                getPostData("Post Details", {}); 
            }
            */    
            if(dp_link_uri != undefined && dp_link_uri != null)
            {
                //getPostDataFetchKey();
                getPostDataFetchKeyNew();
            }     
        }          

    }, []);

    const FollowingFollowersText = ({ text }) => {
        //const match = text.match(/\{(\d+)\}\s*(.+)/); 
        const match = text.match(/\{([\w]+)\}\s*(.+)/);
        if (!match) return text; // fallback if string format is unexpected

        const [, count, label] = match;

        // convert first letter to uppercase, rest lowercase
        //const camelLabel = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();    

        return (
            <span>
                <b className="fs16B "  onClick={clickCenterModalOpen}>{count}</b> <span className="pd05" onClick={clickCenterModalOpen}>{label}</span>
            </span>
        );
    };   
    
    var BusnessCreatorsProfileCategory = () => {
        if(postCreatorInfo.Profile_Type == "2") // Creators only
        {
            if(postCreatorInfo.User_Handle=="")
            {
                return (<>
                    {postCreatorInfo.Profile_Category!="" && <span>{postCreatorInfo.Profile_Category}</span>}                       
                </>);
            }
            else
            {
                return (<>
                    {postCreatorInfo.Profile_Category!="" && <span> | {postCreatorInfo.Profile_Category}</span>}
                </>);
            }            
        }
    }

    var BusnessFollowingFollowers = () => {
        // "Profile_Type": "1"
        if(postCreatorInfo.Profile_Type == "1") // Business
        {
            return (<>
                <div className="col-sm-12 fs14N p0 m5Z">
                    <div className='row'>
                        <div className="col-sm-6 p0 w50p" onClick={clickCenterModalOpen}>
                            <FollowingFollowersText text={postCreatorInfo.Following_Count} />
                        </div>
                        <div className="col-sm-6 p0 w50p" onClick={clickCenterModalOpen}>
                            <FollowingFollowersText text={postCreatorInfo.Followers_Count} />
                        </div>
                        {/* <div className="col-sm-6 p0 w50p"><b>{postCreatorInfo.Following_Count}</b> <span className="pd010">Following</span></div>
                        <div className="col-sm-6 p0 w50p"><b>{postCreatorInfo.Followers_Count}</b> <span className="pd010">Followers</span></div> */}
                    </div>
                </div>
            </>);
        }
        else
        {
            return (<></>);
        }
    };



    const postProfileView = () => {

        //console.log("postCreatorInfo", postCreatorInfo);

        // Badge icon
        // Badge_Status : "1"
        // Profile_Type : "1" // Business
        // Profile_Type : "2" // Creator
        if (postCreatorInfo.Profile_Type == "1" && postCreatorInfo.Badge_Status == "1") {
            var badgeImg = business_badge
            var Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        } else if ((postCreatorInfo.Profile_Type == "0" || postCreatorInfo.Profile_Type == "2") && postCreatorInfo.Badge_Status == "1") {
            var badgeImg = verified_icon
            var Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        } else {
            var badgeImg = "";
            var Badge_Img = "";
        }

        var backgroundColor = postCreatorInfo.Cover_BG_Color;

        if(postCreatorInfo.User_Profile_Cover == "")
            backgroundColor = "#556080";

            return (<>
                <div className="row">
                    <div className="col col-sm-12 p0 mt10 profile-img-box">
                        <div className="row">
                            <div className=" col col-sm-12 p0 profile-img-box-image" style={{backgroundColor:backgroundColor }}>
                                <img className='profile-img' src={postCreatorInfo.User_Profile_Cover} onClick={clickCenterModalOpen}>
                                </img>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mtminus60 explr-profile p10">
                    <div className="col-sm-4 explr-col-3 p0 mtb10">
                        <img className="circle_profile_large130" 
                            src={postCreatorInfo.Creater_ProfilePic}
                            alt="image_profile" onClick={clickCenterModalOpen}></img>                        
                    </div>
                    <div className="col-sm-4 explr-col-3 p0">
                        
                    </div>
                    <div className="col col-sm-4 explr-col-3 p0 ExplurgedLevelIconViewProfileBox">

                        {ExplurgedLevelIconViewProfile()}
                        
                    </div>
                </div>
                <div className="row p15Z">                    
                    <div className="col-sm-12 fs16B p0" onClick={clickCenterModalOpen}>
                        <span><b>{postCreatorInfo.Creater_Name}</b></span> 
                        &nbsp;{Badge_Img}
                    </div>
                    <div className="col-sm-12 fs14N p0 m5Z" onClick={clickCenterModalOpen}>
                        <span>{postCreatorInfo.User_Handle}</span> 
                        {BusnessCreatorsProfileCategory()}
                    </div>
                    <div className="col-sm-12 fs14N p0" onClick={clickCenterModalOpen}>
                        {postCreatorInfo.User_Gender_Text!="" && <span>{postCreatorInfo.User_Gender_Text} | </span>}
                        <span>{postCreatorInfo.User_City}, </span>
                        <span>{postCreatorInfo.User_Country}</span>     
                    </div>
                    {BusnessFollowingFollowers()}
                    <div className="col-sm-12 fs14N p0 link-color m5Z">
                        {/* <span>{postCreatorInfo.User_Bio2}</span>
                        <br></br>
                        <span>{postCreatorInfo.User_Bio}</span>                         */}
                        {postCreatorInfo.User_Bio && <ReadMore>{postCreatorInfo.User_Bio}</ReadMore>}   
                    </div>
                </div>
                <div className="row profileButtonsBox mzz10">                    
                    <div className="col profileButtonsBoxInner col-sm-5">
                        <Button variant="primary profileButtons profileButtonsFollow" onClick={clickCenterModalOpen}>+ Follow</Button>
                    </div>
                    <div className="col profileButtonsBoxInner profileButtonsBoxInnerRight col-sm-4 p-0">
                        <Button variant="primary profileButtons profileButtonsMessage" onClick={clickCenterModalOpen}>Message</Button>   
                    </div>
                    <div className="col profileButtonsBoxInner profileButtonsBoxInnerRight col-sm-3">
                        <Button variant="primary profileButtons profileButtonsShare" onClick={clickCenterModalOpen} >
                            <img src={profileShare}></img>
                        </Button>   
                    </div>
                </div>
            </>);
 
    }
    const profileSummary = () => {

        var miles_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["miles"].Text_Color:'';        
        var continent_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["continent"].Text_Color:'';
        var country_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["country"].Text_Color:'';

        var city_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["city"].Text_Color:'';
        var place_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["place"].Text_Color:'';
        var kudo_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["kudo"].Text_Color:'';
        var fellow_Text_Color = postCreatorInfo.explurgerSummaryData != undefined ? postCreatorInfo.explurgerSummaryData["fellow"].Text_Color:'';
        return (<>
            {profileSummaryNewUI()}
        </>);                     
        return (<>
            {profileSummaryNewUI()}
            <div className="row">
                <div className="col col-sm-12">
                    <div className='row'>
                        {/* <div className="col-sm-1 p0 mapProfileMapBox">
                            <img className='Map_Profile_Icon' src={mapProfileMap}></img><br></br>
                            <span>Map</span>
                        </div> */}
                        <div className="col-sm-12 p0 mapProfileSummeryBox">
                            <span>Explurger Summary</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row profile-summary-box">                    


                <div className="col-sm-12 p0" >
                    <img className='profile-summary-place-jpg' src={profilePlace}></img>
                </div>


                <div className="col-sm-12 p2010 profile-summary-place-img" >

                    <div className="row profile-summary-box-list" >
                        <div className="col p0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={miles_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["miles"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["miles"].Text}                                            
                                </text> 
                            </svg>
                        </div>
                        <div className="col p0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={continent_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["continent"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["continent"].Text}                                            
                                </text> 
                            </svg>                            
                        </div>
                        <div className="col p0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={country_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["country"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["country"].Text}                                            
                                </text> 
                            </svg>
                        </div>
                        <div className="col p0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={city_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["city"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["city"].Text}                                            
                                </text> 
                            </svg>
                        </div>
                    </div>
                    <div className="row profile-summary-box-list profile-summary-box-list-2" >
                        <div className="col p0 profile-hex-box2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={place_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["place"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["place"].Text}                                            
                                </text> 
                            </svg>
                        </div>
                        <div className="col p0 profile-hex-box2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={kudo_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["kudo"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["kudo"].Text}                                            
                                </text> 
                            </svg>                            
                        </div>
                        <div className="col p0 profile-hex-box2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="image_profile">
                                <polygon points="50 1 95 25 95 75 50 99 5 75 5 25" fill={fellow_Text_Color} className="strokclass"></polygon>                               
                                <text className='summary-hex-count' x="50" y="45" textAnchor="middle" fill="black" fontSize="16" fontWeight="bold"> 
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["fellow"].Count} 
                                </text> 
                                <text className='summary-hex-text' x="50" y="70" textAnchor="middle" fill="black" fontSize="13" fontWeight="bold">
                                    {postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["fellow"].Text}                                            
                                </text> 
                            </svg>
                        </div>
                        <div className="col p0"></div>                    
                    </div>
                </div>

            </div>
        </>);

    }
    
    const profileSummaryNewUI = () => {
         
        return (<>
            <div className="row">
                <div className="col col-sm-12">
                    <div className='row'>                        
                        <div className="col-sm-12 p0 mapProfileSummeryBox">
                            <span>Journey So Far</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row profile-summary-box" >                    

                <div className="row">
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image' src={globeIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["continent"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["continent"].Text}</div>
                        </div>
                    </div>
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image' src={countriesIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["country"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["country"].Text}</div>
                        </div>
                    </div>
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image' src={citiesIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["city"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["city"].Text}</div>
                        </div>
                    </div>
                </div>
                <div className="row pt-2 pb-2">
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image' src={placesIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["place"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["place"].Text}</div>
                        </div>
                    </div>
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image miles' src={milesIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["miles"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["miles"].Text}</div>
                        </div>
                    </div>
                    <div className="col p-1">
                        <div className="row stats-card p-2" onClick={clickCenterModalOpen}>
                            <div className="stats-icon col-3 p0"><img className='journey_so_for_image' src={followersIcon}></img></div>
                            <div className="stats-value col-9 p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["fellow"].Count}</div>
                            <div className="stats-label col-12 text-right p0">{postCreatorInfo.explurgerSummaryData != undefined && postCreatorInfo.explurgerSummaryData["fellow"].Text}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>);

    }    
    

    var urlRegex = /(https?:\/\/[^\s]+)/g;
    //const linkRegex = /(https?\:\/\/)?(www\.)?[^\s]+\.[^\s]+/g;
    const linkRegex = /\b(https?:\/\/[^\s]+|www\.[^\s]+)\b/g;
    const linkRegexHttpWww = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g;
    const hasHashRegex = /(?:^|\W)#(\w+)(?!\w)/g;
    const tagHashRegex = /(?:^|\W)@(\w+)(?!\w)/g;
    const regexNewLineCount = /$/mg;

    function urlifyOld(text) {        
        return text.replace(linkRegex, function(url) {

            let withProtocol = url
        
            if(!withProtocol.startsWith("http")) {
              withProtocol = "http://" + url
            }
           
            const newStr = `<a href="${withProtocol}" target="_blank" >${url}</a>`

            //return '<a href="' + url + '" target="_blank">' + url + '</a>';
            return newStr;
        })
    }

    function urlify(text) {        
        return text.replace(linkRegex, function(url) {
            let withProtocol = url;
            if(!withProtocol.startsWith("http")) {
                withProtocol = "http://" + url;
            }
            return `<a href="${withProtocol}" target="_blank">${url}</a>`;
        });
    }

    function replaceNLWithBr(txt) {
        return txt.replaceAll(/\n/g, "<br />");
    }

    function hashify(text) {        
        return text.replaceAll(hasHashRegex, function(hash) {
           
            //var newStr = `<a href="javascript:false" style="color:#2d97f7" onclick="${clickCenterModalOpen}" >${hash}</a>`

            var newStr = `<span style="color:#2d97f7">${hash}</span>`;
            return newStr;
        });
    }

    function tagiify(text) {        
        return text.replaceAll(tagHashRegex, function(hash) {
           
            //var newStr = `<a href="javascript:false" style="color:#2d97f7" onclick="${clickCenterModalOpen}" >${hash}</a>`

            var newStr = `<span style="color:#2d97f7">${hash}</span>`;
            return newStr;
        });
    }    

    function decodeAndSlice(decoded, maxLength = 200) {
        // Step 1: Decode percent-encoding
        //const decoded = decodeURIComponent(input);

        // Step 2: Slice safely to maxLength without breaking UTF-8 characters
        let result = "";
        let count = 0;
        for (const char of decoded) {
            if (count + char.length > maxLength) break;
            result += char;
            count += char.length;
        }

        return result;
    }    


    const ReadMore = ({ children }) => {

        var _Text = children;
        //console.log("ReadMore-", _Text);

        //var post = children;
        if(_Text == undefined) return "";
        var Post_Text = decodeURIComponent(_Text);
        var text_length = 200;
        var mxL = 3;
        var tlns = Post_Text.match(regexNewLineCount).length;
        if(tlns > mxL)
        {
            // calculate length of 2 lines text
            // extract only 3 line
            var textLines = Post_Text.split("\n")
            var text2 = textLines[0] +"\n"+ textLines[1] +"\n"+ textLines[2] +"\n"+ textLines[3];
            var text2Length = text2.length;
            if(text_length > text2Length)
            {
                text_length = text2Length;
            }
        }

        //console.log("Post_Text", Post_Text);

        // Post_Text = urlify(Post_Text);  
        // console.log("Post_Text", Post_Text);        

        // //Post_Text = replaceNLWithBr(Post_Text);
        // Post_Text = hashify(Post_Text);
        // console.log("Post_Text", Post_Text);
        // Post_Text = tagiify(Post_Text);
        // console.log("Post_Text", Post_Text);

        Post_Text = parseTextSinglePass(Post_Text);
        //console.log("Post_Text", Post_Text);

      
               
        let text = Post_Text;  
              
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };

        // text.slice(0, text_length);

        //console.log(text, text_length);

        var slicedtext = decodeAndSlice(text, text_length);

        //console.log(slicedtext);

        slicedtext = replaceNLWithBr(slicedtext);

        if (text.length > text_length || tlns > mxL) {
            return (
                <p className="text">
                    {isReadMore ? ReactHtmlParser(slicedtext) : ReactHtmlParser(text)}
                    <span
                        onClick={clickCenterModalOpen}
                        className="read-or-hide"
                        style={{ color: "blue" }}
                    >
                        {isReadMore ? "...read more" : " show less"}
                    </span>
                </p>
            );
        } else {
            return (<>{ReactHtmlParser(text)}</>)
        }
    };    

    var ExplurgedLevelIconViewProfile = (data) => {
        //var Explurged_Level = parseInt(data.Total_Explurged_Level);
        // var Explurged_Level = parseInt(10000);
        // if (Explurged_Level < 20000) { // Cobalt
        //     return (<><img className='Level_Icon_Profile' src={cobaltLevelIcon}></img></>)
        // } else if (Explurged_Level < 50000) { // Silver
        //     return (<><img className='Level_Icon_Profile' src={silverLevelIcon}></img></>)
        // } else if (Explurged_Level < 100000) { // GOLD
        //     return (<><img className='Level_Icon_Profile' src={goldLevelIcon}></img></>)
        // } else if (Explurged_Level < 500000) { // Spectra
        //     return (<><img className='Level_Icon_Profile' src={spectraLevelIcon}></img></>)
        // } else { // Prime
        //     return (<><img className='Level_Icon_Profile' src={primeLevelIcon}></img></>)
        // }

        
        //return (<><img className='Level_Icon_Profile' src={postCreatorInfo.Level_Img_Icon}></img></>);

        if (postCreatorInfo.Profile_Type == "1") {
            return (<></>);
        }

        return (<>
                        <div className="row">
                            <div className='col col-sm-12 ExplurgedLevelIconViewProfile'>
                                <img className='Level_Icon_Profile' src={postCreatorInfo.Level_Img_Icon} onClick={clickCenterModalOpen}></img>                                
                            </div>
                        </div>
                        <div className="row">
                            <div className='col explr-col-3 Level_Icon_Profile_Text'></div>
                            <div className='col explr-col-9 Level_Icon_Profile_Text'>
                                <span onClick={clickCenterModalOpen}>{postCreatorInfo.Level_Name}</span>
                            </div>
                        </div>      
        </>);  
    }
   

    const clickCenterModalOpen = () => {
        if (parseInt(postCreatorInfo.Post_Count) < 1) {
            document.getElementById('hideNotNowOnDontMissModel').style.display = 'none';
        }
        CenterModalOpen("flex");
    }

    const CenterModalOpen = (display) => {      
        //console.log("ViewProfile-CenterModalOpen ", display);
        var modelBox = document.getElementById('dontMissModalBox');
        modelBox.style.display = display;
        var model = document.getElementById('dontMissModal');
        //console.log("CenterModalOpen ", model, display);
        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);

            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();  

        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox);

            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();             
        }        
    } 

    const ContinueModalOpen = (display) => {      
        if (hasRun.current) {
             return;
        }         
        hasRun.current = true;
        //console.log("ViewProfile-ContinueModalOpen ", display);
        var modelBox = document.getElementById('staticContinueWebsiteBox');
        modelBox.style.display = display;
        var model = document.getElementById('staticContinueWebsite');
        //console.log("ContinueModalOpen ", model, display);

        const modalDialog = model.querySelector('.modal-dialog');

        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);

            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();  

            requestAnimationFrame(() => {
                modalDialog.style.transform = 'translateY(0)';
            });

            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '0';             
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox);

            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();  
            
            modalDialog.style.transform = 'translateY(100vh)';

            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '1000'; 

        }        
    }    

    const profileTop = () => {      
        return (<>            
            <div className='row p0 p0170'>
                <div className='col p0'>
                    <div className={' row block-box p0 block-box-summary'}>

                        <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard2 postCardMP'>
                            <div className='box-1'>
                                {postProfileView()}
                            </div>
                        </div>

                    </div> 
                </div> 
            </div>
        </>);
    } 

    const explurgerSummary = () => {
        
        //console.log("explurgerSummary-", postCreatorInfo, postCreatorInfo.explurgerSummaryData, postCreatorInfo.explurgerSummaryData.length);

        if (!('miles' in postCreatorInfo.explurgerSummaryData))
        {
            return (<></>);
        }    

        return (<>            
            <div className='row p0 p0170'>
                <div className='col p0'>
                    <div className={' row block-box p0 '}>

                        <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard3 p0 m10px00'>
                            <div className={' box-1 '}>
                                {profileSummary()}                                
                            </div>
                        </div>

                    </div> 
                </div> 
            </div>
        </>);
    }

    const postSummary = () => {      
        return (<>            
            <div className='row p0 p0170'>
                <div className='col p0'>
                    <div className={' row block-box p0 block-box-post'}>

                        <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard3 p0 m10px0'>
                            <div className={' box-1 '}>
                                <div className="row">
                                    <div className="col col-sm-12">
                                        <div className='row'>                                            
                                            <div className="col col-sm-6 postSummeryBox">
                                                <span>{postCreatorInfo.Post_Count}</span>&nbsp;                                                                                        
                                                <span>{postCreatorInfo.Explurge_Msg}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                                                
                            </div>
                        </div>

                    </div> 
                </div> 
            </div>
        </>);
    }    

    const showProfile = () => {
        // postCreatorInfo
        //if (isActive && postData)
        //if (isActive) 
        // status : true
        // if(data.status && data.code == 200)
        //if (!isActive && postData && postData.status == true && postData.code == 200)
        if (!isActive && postData && postData.data != undefined)
        {
            // CenterModalOpen("flex");
            // let element = document.querySelector("a.notNow");
            // if (element) {
            //     element.textContent = "Continue on the website"; // sets the text inside the <a> tag
            // }

            ContinueModalOpen("flex");

            return (<>
                {profileTop()}
                {explurgerSummary()}
                {postSummary()}
                {/* <ViewPost attr_id={id} sendDataToParent={handleDataFromChild} resfreshAllowed="0"></ViewPost> */}
                <ViewPost attr_id={dataFetchKey} sendDataToParent={handleDataFromChild} sendDataToParentDontDismissModelHide={handleDataFromChildDontDismissModelHide} dontDismissModelHide={dontDismissModelHide} resfreshAllowed="0"></ViewPost>                
            </>);
        }
        return (<></>);
    }

    const noProfileYet = () => {
        if (!isActive && postData && postData.length==0)
        {
            return (<>
                <div className='no_explurge_yet row p0 p0170'>
                    {/* <div className='col col-sm-12 p0'>No User</div> */}
                    {/* <div className='col col-sm-12 p0 splashScreen'><img src={splashScreen}></img></div> */}
                    <ExplurgerPageNotFoundMock></ExplurgerPageNotFoundMock>
                </div>
            </>);
        }
        return (<></>);
    }   
    
    const loaderBox = () => {
        if (isActive)
        {
            return (<>
                <div className='loaderbox'>
                    <HashLoader key={"p-mainLoader-"+isActive} className='mainLoader'></HashLoader>
                </div>
                {/* <div className='splashScreen'><img src={splashScreen}></img></div> */}
            </>);
        }
        return (<></>);
    }    

    return (<>
    <div className="container-fluid m0 p0" id="my-container-element">
        <TopComponent></TopComponent>
        <div className="row main_container">
            
            {/* <div className='col-lg-4 col-xl-4 p0'></div> */}
            <div className='col-lg-12 col-xl-12 p0 max428'>

                    
                    <div className=' scroll-div '>
                    
                        <div className='loader text-center p0170'>
                            {isActive && loaderBox()}
                            {/* {isActive && <HashLoader key="mainLoader" className='mainLoader'></HashLoader>} */}
                        </div>

                        {showProfile()}

                        {noProfileYet()}

                    </div>
                
			</div>
            {/* <div className='col-lg-4 col-xl-4 p0'></div> */}
		</div>
	</div>
   
    <CommonComponent postCreatorInfo={postCreatorInfo} sendDataToParent={handleDataFromChildCommonComponent} 
    // p_handleChildClick_lockScrollNew={handleChildClick_lockScrollNew}
    // p_handleChildClick_unlockScrollNew={handleChildClick_unlockScrollNew}
    // p_handleChildClick_preventTouchScroll={handleChildClick_preventTouchScroll}
    // p_handleChildClick_enableTouchBlock={handleChildClick_enableTouchBlock}
    // p_handleChildClick_disableTouchBlock={handleChildClick_disableTouchBlock}
    ></CommonComponent>
    <Helmet>
        <title>{metaTagData.APP_TITLE}</title>
        
        <meta name="description" content={metaTagData.APP_DESCRIPTION} />
        <meta name="keywords" content={constants.APP_KEYWORDS} /> 

        <meta property="og:title" content={metaTagData.APP_TITLE} />
        <meta property="og:description" content={metaTagData.APP_DESCRIPTION} />
        <meta property="og:image" content={metaTagData.APP_IMAGE} />        
    </Helmet> 
    </>)
}